export const PageMargin = "10vw";
